import { initializeApp } from 'firebase/app';
import { getAuth, onAuthStateChanged, deleteUser, signOut, reauthenticateWithCredential, OAuthProvider, GoogleAuthProvider, signInWithPopup, EmailAuthProvider } from 'firebase/auth';
import { getFirestore, collection, doc, onSnapshot, query, where, addDoc, getDocs, getDoc } from 'firebase/firestore';
import { getFunctions, httpsCallable } from 'firebase/functions';
import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import enTranslation from './locales/en/translation.json';
import deTranslation from './locales/de/translation.json';
import frTranslation from './locales/fr/translation.json';
import esTranslation from './locales/es/translation.json';

import './css/style.css';
import './css/all.min.css';
import './css/v4-shims.min.css';

const app = initializeApp({
    apiKey: "AIzaSyBzQubp8v2ais9gVcf_GCsvdGqs7CduaDk",
    authDomain: "fiveloop-9efa7.firebaseapp.com",
    databaseURL: "https://fiveloop-9efa7-default-rtdb.firebaseio.com",
    projectId: "fiveloop-9efa7",
    storageBucket: "fiveloop-9efa7.appspot.com",
    messagingSenderId: "209102879062",
    appId: "1:209102879062:web:4e5c724e72834cf885fef7"
});

document.addEventListener('DOMContentLoaded', function() {
  setupi18n()
});

async function setupi18n(){
  await i18n
  .use(LanguageDetector) // Detects user language
  .init({
    fallbackLng: 'en',
    resources: {
      en: {
        translation: enTranslation
      },
      de: {
        translation: deTranslation
      },
      fr: {
        translation: frTranslation
      },
      es: {
        translation: esTranslation
      }
    }
  });

  $('.txtAccount').html(i18n.t('stringAccount'));
  $('.txtEmail').html(i18n.t('stringEmail'));
  $('.txtSubscription').html(i18n.t('stringSubscription'));
  $('.txtDeleteAccount').html(i18n.t('stringDeleteAccount'));
  $('.txtValidTill').html(i18n.t('stringValidTill'));
  $('.txtAutoRenewal').html(i18n.t('stringAutoRenewal'));
  $('.txtChangePlan').html(i18n.t('stringChangePlan'));
  $('.txtAreYouSure').html(i18n.t('stringAreYouSure'));
  $('.txtDeleteAccountinfo1').html(i18n.t('stringDeleteAccountinfo1'));
  $('.txtDeleteAccountinfo2').html(i18n.t('stringDeleteAccountinfo2'));
  $('.txtDeleteAccountinfo3').html(i18n.t('stringDeleteAccountinfo3'));
  $('#inputPassword').attr('placeholder', i18n.t('stringPassword'));
  $('.txtYesDeleteNow').html(i18n.t('stringYesDeleteNow'));
  
}

const auth = getAuth(app);
const db = getFirestore(app);
const functions = getFunctions(app);


onAuthStateChanged(auth, (user) => {
  if (user) {
    // User is signed in, see docs for a list of available properties
    document.getElementById("lbl_email").innerHTML = user.email
    document.getElementById("navbarUsername").innerHTML = user.email
    userHasPremiumCustomClaim().then((hasPremium) => {
      if (hasPremium) {
        document.getElementById("navbarPremiumTag").innerHTML = "Premium"
        if (hasPremiumLemonSqueezy) {
          getSubscriptionDetailsForLemonSqueezy()
        } else if (hasPremiumStripe) {
          getSubscriptionDetailsForStripe()
        } else if (hasPremiumRc) {
          getSubscriptionDetailsForRc()
        }
        
      } else {
        document.getElementById("premiumInfoBtn").classList.remove("hidedisplay")
      }
      document.getElementById("navbarUsersettings").classList.remove('hide')
    });
  } else {
    // User is signed out
    window.location.replace("login.html");
  }
});


async function getSubscriptionDetailsForRc() {

  const rcSubQueryDocRef = doc(db, "rcCustomers", auth.currentUser.uid);

  const docSnap = await getDoc(rcSubQueryDocRef);

    if (!docSnap.exists()) {
      console.log("Document does not exist");
      return;
    }

    const docData = docSnap.data();
    const subscriptions = docData.subscriptions;
    if (subscriptions) {
      const subscriptionTypes = ["com.stephanduechtel.fiveloop.premium.monthly", "com.stephanduechtel.fiveloop.premium.yearly"];
      
      for (const subscriptionType of subscriptionTypes) {
        const subscriptionDetails = subscriptions[subscriptionType];
        if (subscriptionDetails) {
          const expiresDateString = subscriptionDetails.expires_date;
          if (expiresDateString) {
            // Assuming expires_date is a String in ISO8601 format, convert it to a Date
            const expiresDate = new Date(expiresDateString);
            console.log(`Subscription ${subscriptionType} expires on: ${expiresDate.toDateString()}`);
            // Adjust the date format as needed
            const planEndDate = expiresDate.toLocaleDateString(); // Adjust based on your specific requirements
            console.log(`Formatted End Date: ${planEndDate}`);
            document.getElementById("noPlan").classList.add('hidedisplay')
            document.getElementById("planDetailsDiv").classList.remove('hidedisplay')
            document.getElementById("lbl_autorenewal").innerHTML = i18n.t('stringInactive')
            document.getElementById("lbl_validthru").innerHTML = planEndDate
            break; // Stop the loop once a valid subscription is found
          }
        }
      }


      const managementUrl = docData.management_url;
      if (managementUrl) {
        console.log(`Management URL: ${managementUrl}`); // Handle the management URL as needed 
        managementUrlRc = managementUrl       
      }
    } else {
      console.log("No subscriptions found");
    }


}

var managementUrlRc = ""
var managementUrlLemonSqueezy = ""

async function getSubscriptionDetailsForLemonSqueezy(){

    const lemonSubQuery = query(collection(db, "lemonSqueezyCustomers", auth.currentUser.uid, "subscriptions"), where("hasPremiumAccess", "==", true));

    const lemonSubscriptions = await getDocs(lemonSubQuery)
    const doc = lemonSubscriptions.docs[0];
    if (typeof doc !== "undefined"){
        const data = doc.data()
        document.getElementById("noPlan").classList.add('hidedisplay')
        document.getElementById("planDetailsDiv").classList.remove('hidedisplay')

        const dateString = data.renewsAt || data.endsAt || data.trialEndsAt
        if (dateString) {
          const date = new Date(dateString)
          document.getElementById("lbl_validthru").innerHTML = date.toLocaleDateString()
        }

        if (data.status === "cancelled" || data.endsAt){
            document.getElementById("lbl_autorenewal").innerHTML = i18n.t('stringInactive')
        } else {
            document.getElementById("lbl_autorenewal").innerHTML = i18n.t('stringActive')
        }

        if (data.urls) {
          managementUrlLemonSqueezy = data.urls.customer_portal || data.urls.update_payment_method || ""
        }
    }
    

}

async function getSubscriptionDetailsForStripe(){

    const stripeSubQuery = query(collection(db, "stripeCustomers", auth.currentUser.uid, "subscriptions"), where("status", "in", ["trialing", "active"]));

    const stripeSubscriptions = await getDocs(stripeSubQuery)
    const doc = stripeSubscriptions.docs[0];
    if (typeof doc !== "undefined"){
        document.getElementById("noPlan").classList.add('hidedisplay')
        document.getElementById("planDetailsDiv").classList.remove('hidedisplay')
        var unix_timestamp = doc.data().current_period_end.seconds
        var date = new Date(unix_timestamp * 1000)
        document.getElementById("lbl_validthru").innerHTML = date.toLocaleDateString()
        const item = doc.data().items[0]
    
        const cancel_at_period_end = doc.data().cancel_at_period_end
        if (cancel_at_period_end){
            document.getElementById("lbl_autorenewal").innerHTML = i18n.t('stringInactive')
        } else {
            document.getElementById("lbl_autorenewal").innerHTML = i18n.t('stringActive')
        }
    }
    

}

// Get the modal
var modal = document.getElementById("myModal");
// Get the <span> element that closes the modal
var span = document.getElementsByClassName("close")[0];
// When the user clicks on <span> (x), close the modal
span.onclick = function() {
  closeModal()
}
// When the user clicks anywhere outside of the modal, close it
window.onclick = function(event) {
  if (event.target == modal) {
    closeModal()
  }
}
function closeModal(){
  modal.style.display = "none";
  if (auth.currentUser.providerData[0].providerId == "google.com" || auth.currentUser.providerData[0].providerId == "apple.com") {
    $("#otherProviderInfo").addClass("hidedisplay");
  } else {
    $("#ownProviderInfo").addClass("hidedisplay");
  }
  document.getElementById("inputPassword").value = ""
}
function toggleModal() {
  modal.style.display = "block";
  if (auth.currentUser.providerData[0].providerId == "google.com" || auth.currentUser.providerData[0].providerId == "apple.com") {
    $("#otherProviderInfo").removeClass("hidedisplay");
  } else {
    $("#ownProviderInfo").removeClass("hidedisplay");
  }
}

$("#deleteAccountBtn").click(function(){
    toggleModal()
});

$("#deleteAccountBtn2").click(function(){
    if (auth.currentUser.providerData[0].providerId == "google.com"){
        var provider = new GoogleAuthProvider();
        signInWithPopup(auth, provider).then((result) => {
            deleteUserAccount()
        }).catch((error) => {
            alert(error)
        });
    } else if (auth.currentUser.providerData[0].providerId == "apple.com"){
        var provider = new OAuthProvider('apple.com');
        signInWithPopup(auth, provider).then((result) => {
            deleteUserAccount()
        }).catch((error) => {
            alert(error)
        });
    } else {
        const credential = EmailAuthProvider.credential(
            auth.currentUser.email,
            document.getElementById("inputPassword").value
        )
        reauthenticateWithCredential(auth.currentUser, credential).then(() => {
            deleteUserAccount()
          }).catch((error) => {
            alert(error)
          });
    }
});

function deleteUserAccount() {
    // ask if user is really sure
    deleteUser(auth.currentUser).then(() => {
        // User deleted.
      }).catch((error) => {
        // An error ocurred
        // ...
        alert(error);
      });
}


$("#changeSubscriptionBtn").click(function(){
  if (hasPremiumLemonSqueezy) {
    if (managementUrlLemonSqueezy != ""){
      window.location.assign(managementUrlLemonSqueezy);
    }
  } else if (hasPremiumStripe) {
    getStripePortalLink()
  } else if (hasPremiumRc) {
    if (managementUrlRc != ""){
      window.location.assign(managementUrlRc);
    }
  }

});

var stripePortalLinkLoading = false

function getStripePortalLink() {

    if (stripePortalLinkLoading){
        return
    }

    stripePortalLinkLoading = true

    $("#changeSubscriptionBtn").addClass("halfopacity");
    $("#changeSubscriptionBtn").find('i').first().removeClass("hidedisplay");
    $("#changeSubscriptionBtn").find('span').first().addClass("hidedisplay");
        
    const createPortalLink = httpsCallable(functions, 'ext-firestore-stripe-payments-createPortalLink');
    createPortalLink({
        returnUrl: window.location.origin,
        locale: "auto"
      })
    .then((result) => {
        // Read result of the Cloud Function.
        const data = result.data;
        const sanitizedMessage = data.text;
        $("#changeSubscriptionBtn").removeClass("halfopacity");
        $("#changeSubscriptionBtn").find('i').first().addClass("hidedisplay");
        $("#changeSubscriptionBtn").find('span').first().removeClass("hidedisplay");
        stripePortalLinkLoading = false
        window.location.assign(data.url);
    })
    .catch((error) => {
        // Getting the Error details.
        const code = error.code;
        const message = error.message;
        const details = error.details;
        stripePortalLinkLoading = false
        $("#changeSubscriptionBtn").removeClass("halfopacity");
        $("#changeSubscriptionBtn").find('i').first().addClass("hidedisplay");
        $("#changeSubscriptionBtn").find('span').first().removeClass("hidedisplay");
        console.log(error.code)
        console.log(error.message)
        console.log(error.details)
    });

}

var hasPremiumRc = false
var hasPremiumStripe = false
var hasPremiumLemonSqueezy = false

async function userHasPremiumCustomClaim() {
  await auth.currentUser.getIdToken(true); // Force refresh to get the latest tokens
  const decodedToken = await auth.currentUser.getIdTokenResult();
  const stripeRole = decodedToken.claims.stripeRole;
  const lemonSqueezyRole = decodedToken.claims.lemonSqueezyRole;
  const revenueCatEntitlements = decodedToken.claims.revenueCatEntitlements;
  // Check if stripeRole is premium
  const hasPremiumStripeRole = stripeRole === "premium";
  // Check if lemonSqueezyRole is premium
  const hasPremiumLemonSqueezyRole = lemonSqueezyRole === "premium";
  // Check if revenueCatEntitlements contains "Premium"
  const hasPremiumRevenueCat = Boolean(revenueCatEntitlements && revenueCatEntitlements.includes("Premium"));
  hasPremiumRc = hasPremiumRevenueCat
  hasPremiumStripe = hasPremiumStripeRole
  hasPremiumLemonSqueezy = hasPremiumLemonSqueezyRole
  
  console.log("hasPremiumRc "+hasPremiumRc)
  console.log("hasPremiumStripe "+hasPremiumStripe)
  console.log("hasPremiumLemonSqueezy "+hasPremiumLemonSqueezy)
  // Return true if either condition is met
  return hasPremiumStripeRole || hasPremiumLemonSqueezyRole || hasPremiumRevenueCat;
}

$(document).on('click', '#logoutBtn', function() {
    signOut(auth).then(() => {
      // Sign-out successful.
    }).catch((error) => {
      // An error happened.
      alert(error)
    });
  });
